<template>
  <div class="m-container">
    <m_header></m_header>
    <!-- 样式二 -->
    <div class="">
      <div class="">
        <div style="text-align: center;font-weight: bold;margin: 30px 0 0 0;font-size: 18px;">
          院况简介
        </div>
        <div style="text-align: center;margin: 30px 0 0 0;">
        </div>
        <div style="display: flex;align-items: center;justify-content: center;">
          <div style="width: 680px;padding: 10px 0 0 0;">
            <div class="m-ruzhu-tit">院况简介</div>
            <div class="m-ruzhu-cont">北京六十甲子系统科学研究院有限公司，隶属于央火工业设计集团，是一家具有创新活力的专业科研机构。自成立以来，六十甲子科研院便专注于系统科学领域，致力于攻克国家发展在资源环境方面遇到的重大科技难题，以强化自主创新能力和推动可持续发展为核心目标，现已逐步成长为中国系统科学领域内极具创新活力的领军研究力量。六十甲子科研院旨在成为支撑国家区域可持续发展战略实施的关键科技支柱，为国家的发展贡献力量。</div>
            <div class="m-ruzhu-tit">定位与使命</div>
            <div class="m-ruzhu-cont">六十甲子科研院的核心定位是攻克地理环境、建筑环境等自然科学领域中对人类社会产生深远影响的重大科技难题。其使命在于通过持续的科研创新，构建服务、引领和支撑中国区域可持续发展的资源环境研究战略科技力量。同时，六十甲子科研院积极致力于成为国家在区域发展、资源高效利用、环境综合整治及生态文明建设等方面的核心思想库和人才摇篮，并奋力迈向国际地理科学、资源科学及生态建设领域的顶尖综合性研究机构行列，为国家的科技进步和社会发展作出卓越贡献。</div>
            <div class="m-ruzhu-tit">组织结构与研究领域</div>
            <div class="m-ruzhu-cont">六十甲子科研院下设四大核心研究中心，形成系统化的研究架构：</div>
            <div class="m-ruzhu-cont">建筑环境研究中心：专注于建筑环境领域的系统性研究。</div>
            <div class="m-ruzhu-cont">自然科学与试验发展研究中心：聚焦基础自然科学探索与试验技术研发。</div>
            <div class="m-ruzhu-cont">区域可持续发展研究中心：致力于区域可持续发展战略、模式与政策研究。</div>
            <div class="m-ruzhu-cont">大数据研究中心：负责数据采集、分析、建模及系统科学数据共享标准体系的构建与维护。</div>
            <div class="m-ruzhu-cont">四大中心协同构建了全面的系统科学数据共享体系，有力支撑了跨学科、跨领域的综合研究活动。</div>
            <div class="m-ruzhu-tit">科研方向与特点</div>
            <div class="m-ruzhu-cont">核心方向：资源环境重大科技难题，服务于国家整体发展布局与长远规划。</div>
            <div class="m-ruzhu-cont">空间尺度广泛：涵盖全球、国际、周边国家、全国乃至国内关键区域等多个层次。</div>
            <div class="m-ruzhu-cont">学科交叉融合：深度整合了自然科学、地理科学、建筑环境科学、系统科学及数据科学等多个学科的前沿成果。</div>
            <div class="m-ruzhu-cont">关键技术突破：依托前沿技术，成功研发出高效的系统服务评估模型等实用工具。</div>
            <div class="m-ruzhu-cont">目标高地：致力于成为全球及国家层面的资源环境与系统科学研究高地</div>
            <div class="m-ruzhu-tit">社会贡献</div>
            <div class="m-ruzhu-cont">六十甲子科研院的科研成果直接服务于国家战略需求，在自然资源管理、生态环境保护、区域协调发展、生态文明建设等领域提供科学支撑和决策依据，是国家在相关领域科研与实践的重要力量。</div>
          </div>
        </div>
      </div>
    </div>
    <m_bottom></m_bottom>
  </div>
</template>

<script>

export default {
  name: 'jianJie',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style>
.m-ruzhu-tit {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 0 0;
}
.m-ruzhu-cont {
  font-size: 16px;
  margin: 5px 0 0 0;
  line-height: 40px;
  text-indent:2em;
}
</style>



// WEBPACK FOOTER //
// src/components/JianJie.vue